module.exports = __webpack_public_path__ + "d9e8b2431a849fc6f6d74ab01ece32a5.png";